import { z } from "zod";
import { DesignSystem } from "../dsm/design-system";
import { User } from "../users/user";
import { Workspace } from "../workspace";
import { WorkspaceRoleSchema } from "../workspace/workspace-role";

/**
 * Object describing who is going to receive the email.
 *
 * Normally recepient is just an email, however in some cases email can be tailored
 * for who receives it. In this case the email has cutomization based on the role of the
 * recepient in the workspace (or design design system).
 */
export const DesignSystemInviteEmailRecipient = z.object({
  email: z.string(),
  role: WorkspaceRoleSchema,
});

/**
 * Object describing the necessary data to send an email notifying a user that
 * they've been added to a design system.
 */
export const DesignSystemInviteEmailData = z.object({
  workspace: Workspace,
  designSystem: DesignSystem,
  invitedBy: User,
  documentationDomain: z.string().optional(),
});

export type DesignSystemInviteEmailRecipient = z.infer<typeof DesignSystemInviteEmailRecipient>;
export type DesignSystemInviteEmailData = z.infer<typeof DesignSystemInviteEmailData>;
